import { cn } from "./utils";

export function GitRefspec({ refspec, current = false }: { refspec: string; current?: boolean }) {
	const currentClasses = [
		"bg-light-spectrum-blue",
		"text-dark-spectrum-blue",
		"group-data-[active=true]:bg-dark-spectrum-blue",
		"group-data-[state=active]:bg-dark-spectrum-blue",
		"group-data-[active=true]:text-light-spectrum-blue",
		"group-data-[state=active]:text-light-spectrum-blue",
	];

	const defaultClasses = [
		"bg-light-spectrum-gray",
		"text-dark-spectrum-gray",
		"group-data-[active=true]:bg-dark-spectrum-gray",
		"group-data-[state=active]:bg-dark-spectrum-gray",
		"group-data-[active=true]:text-light-spectrum-gray",
		"group-data-[state=active]:text-light-spectrum-gray",
	];

	return (
		<code
			className={cn(
				current ? currentClasses : defaultClasses,
				"font-medium",
				"py-0.5",
				"px-2",
				"rounded",
				"text-xs"
			)}
		>
			{refspec}
		</code>
	);
}
